import "./Header.css";

function Header() {
  return (
    <div className="Header">
      <h1>Drewdle</h1>
    </div>
  );
}

export default Header;
